import script from "./AddLogisticsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddLogisticsModal.vue?vue&type=script&setup=true&lang=js"

import "./AddLogisticsModal.vue?vue&type=style&index=0&id=60f332be&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60f332be"]])

export default __exports__